import { BrowserRouter } from 'react-router-dom';

import Content from './Content';
import { AppProvider } from '../shared';
import { UserProvider } from '../shared';
import { AuthProvider } from '../shared';
import { Notifications } from '../shared';
import { ThemeProvider } from '../shared';

const App: React.FC = () => {
  return (
    <>
      <Notifications />
      <BrowserRouter>
        <ThemeProvider>
          <AuthProvider>
            <UserProvider>
              <AppProvider>
                <Content />
              </AppProvider>
            </UserProvider>
          </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
    </>
  );
};

export default App;
